/**
 * ImageLoader
 * ───────────
 * Central image loader with deduplication.
 *
 *  1. Already loaded → returns cached result immediately
 *  2. Currently loading → returns the in-flight promise
 *  3. New URL → starts the load, caches the promise
 *
 *   import { imageLoader } from './ImageLoader'
 *   const img = await imageLoader.load('/assets/tree.png')
 */

export class ImageLoader {
  constructor() {
    this._cache = new Map()
    this._resolved = new Map()
  }
  /** Returns the image synchronously if already loaded, otherwise null. */
  get(url) {
    return this._resolved.get(url) ?? null
  }
  load(url) {
    const existing = this._cache.get(url)
    if (existing) return existing
    const promise = new Promise((resolve, reject) => {
      const img = new Image()
      img.onload = () => {
        this._resolved.set(url, img)
        resolve(img)
      }
      img.onerror = err => {
        // evict so a retry can try again
        this._cache.delete(url)
        console.log('fail', url)
        reject(err)
      }
      img.src = url
    })
    this._cache.set(url, promise)
    return promise
  }
}
